import { fetchViewOffer, TViewOfferResponse } from '../../repositories/cian-chat-bot/v1/view-offer';
import { IApplicationContext } from '../../types/applicationContext';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { ETelemetryEvents } from '../../types/telemetry';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

const DEFAULT_ERROR_MESSAGE = 'Ошибка при передаче перехода к объявлению чатбота';

export async function fetchOfferView(
  { httpApi, logger, telemetry }: IApplicationContext,
  offerId: number,
): Promise<void> {
  try {
    const { statusCode, response }: TViewOfferResponse = await fetchViewOffer({
      httpApi,
      parameters: {
        offerId,
      },
    });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.Chatbot,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }
  } catch (error) {
    telemetry.increment(ETelemetryEvents.ChatbotViewOfferFail);

    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.Chatbot,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'cian-chat-bot',
      pathApi: '/v1/view-offer/',
      parameters: JSON.stringify({ offerId }),
    });
  }
}
